<template>
  <div class="statistics-list-page">
    <el-card
      v-if="action !== 'checkTagDetails'"
      class="app-table-container"
      :body-style="{ padding: '0px 0px 20px' }"
    >
      <div slot="header" class="statistics-header">
        <div class="statistics-header-top">
          <div class="statistics-header-left">
            <h3>
              反馈总数：<span>{{ tagCount.TagTotal }}</span>
            </h3>
            <h3>
              已打标签总数：<span>{{ tagCount.TagedCount }}</span>
            </h3>
            <h3>
              未打标签总数：<span>{{ tagCount.unTagCount }}</span>
            </h3>
          </div>
          <div class="statistics-header-right">
            <el-date-picker
              v-model="datePicker"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="timestamp"
              @change="changePicker"
            >
            </el-date-picker>

            <el-popover
              :append-to-body="false"
              placement="bottom"
              trigger="click"
            >
              <div class="statistics-header-export">
                <div class="statistics-header-export-date">
                  <el-select
                    class="statistics-header-export-type"
                    v-model="exportType"
                  >
                    <el-option
                      v-for="item in exportTypeOpts"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  <el-date-picker
                    v-model="exportTagDate"
                    type="daterange"
                    value-format="timestamp"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                  <p class="statistics-header-export-tips">
                    (最多只能导出10000条记录，不选择日期会从当日开始往前导出记录)
                  </p>
                  <el-button
                    type="primary"
                    class="statistics-header-export-config"
                    @click.stop="exportTagData"
                    >确定</el-button
                  >
                </div>
              </div>
              <el-button
                slot="reference"
                class="statistics-header-export-btn"
                type="primary"
                >导出标签</el-button
              >
            </el-popover>

            <!-- <div class="statistics-date-select">
              <span
                v-for="item in dateType"
                :key="item.type"
                class="statistics-date-select-item"
                :class="{
                  'statistics-date-select-active':
                    paramsList.dateType === item.type
                }"
                @click="changeType(item.type)"
                >{{ item.label }}</span
              >
            </div> -->
          </div>
        </div>
        <div class="statistics-header-bottom">
          <div class="statistics-header-bottom-first">
            <div class="left-part">
              <span>版本</span>
              <div class="listSearch">
                <el-input
                  v-model="paramsList.version"
                  clearable
                  @input="onInput"
                  @keyup.enter.native="filterHandle"
                  :placeholder="$t('placeholder.enter')"
                >
                </el-input>
              </div>
            </div>
            <div class="left-part">
              <span>型号</span>
              <div class="listSearch">
                <el-input
                  v-model="paramsList.model"
                  clearable
                  @input="onInput"
                  @keyup.enter.native="filterHandle"
                  :placeholder="$t('placeholder.enter')"
                >
                </el-input>
              </div>
            </div>
            <div class="left-part">
              <span>服务器</span>
              <div class="listSearch">
                <el-select
                  v-model="paramsList.server"
                  clearable
                  @change="filterHandle"
                >
                  <el-option
                    v-for="item in serverOpts"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="left-part">
              <span>客户端类型</span>
              <div class="listSearch">
                <el-select
                  v-model="paramsList.clientType"
                  clearable
                  @change="filterHandle"
                >
                  <el-option
                    v-for="item in clientTypeOpts"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="left-part">
              <button class="global-button-style" @click="getList()">
                {{ $t("commonMsg.search") }}
              </button>
            </div>
          </div>
          <div class="statistics-header-bottom-second"></div>
        </div>
      </div>
      <div class="global-body-wrap statistics-tags-card">
        <TabHeader
          :slideData="tagCategory"
          :tab="tab"
          @headerTabBack="headerTabBack"
        />
        <template v-if="tab !== 'unTags'">
          <div class="global-body-wrap statistics-tags-container funct-table">
            <Table
              :tableProps="tableProps"
              :tableData="tableData"
              :currentPage="paramsList.page"
              :pageSize="paramsList.pageSize"
              @tableHandle="tableHandle"
              :selectCtrl="false"
              @tableSelection="tableSelection"
            />
          </div>
          <Pagination
            class="statistics-tags-pagination"
            :pageSize="paramsList.pageSize"
            :currentPage="paramsList.page"
            :total="total"
            @pageNum="pageNum"
          />
        </template>
        <template v-else-if="tab === 'unTags'">
          <div class="global-body-wrap statistics-tags-container funct-table">
            <Table
              :tableProps="unTagsProps"
              :tableData="tableData"
              align="left"
              :currentPage="unTagsParams.page"
              :pageSize="unTagsParams.pageSize"
              @tableHandle="tableHandle"
              :selectCtrl="false"
              @tableSelection="tableSelection"
            />
          </div>
          <Pagination
            class="statistics-tags-pagination"
            :pageSize="unTagsParams.pageSize"
            :currentPage="unTagsParams.page"
            :total="total"
            @pageNum="unTagsPageNum"
          />
        </template>
      </div>
    </el-card>

    <!-- ===============当前标签详情================= -->
    <el-card
      v-else
      class="app-table-container"
      :body-style="{ padding: '20px' }"
    >
      <div slot="header" class="statistics-header">
        <div class="statistics-header-top">
          <div class="statistics-header-left">
            <h3>
              {{ categoryToText() }}：<span>{{ currentCheckTitle }}</span>
            </h3>
          </div>
          <div class="statistics-header-right">
            <!-- <div class="statistics-date-select">
              <span
                v-for="item in dateType"
                :key="item.type"
                class="statistics-date-select-item"
                :class="{
                  'statistics-date-select-active':
                    detailsParams.dateType === item.type
                }"
                @click="changeDetailsType(item.type)"
                >{{ item.label }}</span
              >
            </div> -->

            <el-date-picker
              v-model="dateDetailsPicker"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="timestamp"
              @change="changeDetailsPicker"
            >
            </el-date-picker>

            <button
              class="global-button-style statistics-date-back-btn"
              @click="closeDetails"
            >
              {{ $t("commonMsg.back") }}
            </button>
          </div>
        </div>
        <div class="statistics-header-bottom">
          <div class="statistics-header-bottom-first">
            <div class="left-part">
              <span>版本</span>
              <div class="listSearch">
                <el-input
                  v-model="detailsParams.version"
                  clearable
                  @input="onDetailInput"
                  @keyup.enter.native="getFeedbackTagDetails"
                  @clear="getFeedbackTagDetails"
                  :placeholder="$t('placeholder.enter')"
                >
                </el-input>
              </div>
            </div>
            <div class="left-part">
              <span>型号</span>
              <div class="listSearch">
                <el-input
                  v-model="detailsParams.model"
                  clearable
                  @input="onDetailInput"
                  @keyup.enter.native="getFeedbackTagDetails"
                  @clear="getFeedbackTagDetails"
                  :placeholder="$t('placeholder.enter')"
                >
                </el-input>
              </div>
            </div>
            <div class="left-part">
              <span>服务器</span>
              <div class="listSearch">
                <el-select
                  v-model="detailsParams.server"
                  clearable
                  @change="getFeedbackTagDetails"
                >
                  <el-option
                    v-for="item in serverOpts"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="left-part">
              <span>客户端类型</span>
              <div class="listSearch">
                <el-select v-model="detailsParams.clientType" disabled>
                  <el-option
                    v-for="item in clientTypeOpts"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="left-part">
              <button
                class="global-button-style"
                @click="getFeedbackTagDetails()"
              >
                {{ $t("commonMsg.search") }}
              </button>
            </div>
          </div>
          <div class="statistics-header-bottom-second"></div>
        </div>
      </div>
      <div class="global-body-wrap">
        <Table
          :tableProps="tagDetailsProps"
          :tableData="detailsData"
          :currentPage="detailsParams.page"
          :pageSize="detailsParams.pageSize"
          @tableHandle="tableHandle"
          :selectCtrl="false"
          align="left"
        />
      </div>
      <Pagination
        :pageSize="detailsParams.pageSize"
        :total="detailsCount"
        @pageNum="detailsPageNum"
      />
    </el-card>
  </div>
</template>

<script>
const defaultDateType = "month";
import TabHeader from "@/components/tabHeader";
import Table from "./components/table";
import Pagination from "@/components/pagination";
export default {
  props: ["refresh"],
  components: {
    TabHeader,
    Table,
    Pagination,
  },
  computed: {
    unTagsProps() {
      let tableProps = [
        {
          prop: "createdAt",
          label: "反馈时间",
          width: 160,
        },
        {
          prop: "model",
          label: "型号",
          width: 100,
        },
        {
          prop: "version",
          label: "版本",
          width: 80,
        },
        {
          prop: "server",
          label: "服务器",
          width: 180,
        },
        {
          prop: "desc",
          label: "内容",
        },
      ];
      return tableProps;
    },
    tableProps() {
      let tableProps = [
        {
          prop: "detail.value",
          label: "标签",
          obj: true,
        },
        {
          prop: "count",
          label: "数量",
        },
      ];
      return tableProps;
    },
    tagDetailsProps() {
      let typeProp = [];

      let tableProps = [
        {
          prop: "model",
          label: "型号",
          width: 100,
        },
        {
          prop: "version",
          label: "版本",
          width: 60,
        },
        {
          prop: "MsgKey",
          label: "MsgKey",
          width: 220,
        },
        {
          prop: "server",
          label: "服务器",
          width: 180,
        },
        {
          prop: "appName",
          label: "地址",
          width: 180,
        },
        {
          prop: "uploadFileUrl",
          label: "截图",
          width: 80,
        },
        {
          prop: "desc",
          label: "内容",
        },
      ];

      if (this.tab === "funct") {
        typeProp = [
          {
            prop: "tagsCate",
            label: "类型",
            width: 200,
          },
          {
            prop: "tagsRet",
            label: "结果",
            width: 200,
          },
        ];
      } else if (this.tab === "cate") {
        typeProp = [
          {
            prop: "tagsFunct",
            label: "功能",
            width: 220,
          },
          {
            prop: "tagsRet",
            label: "结果",
            width: 200,
          },
        ];
      } else if (this.tab === "ret") {
        typeProp = [
          {
            prop: "tagsFunct",
            label: "功能",
            width: 220,
          },
          {
            prop: "tagsCate",
            label: "类型",
            width: 200,
          },
        ];
      }

      tableProps.splice(4, 0, ...typeProp);
      return tableProps;
    },
  },
  data() {
    return {
      datePicker: "",
      dateDetailsPicker: "",
      tab: "funct",
      tableData: [],
      total: 0,
      paramsList: {
        version: "",
        model: "",
        server: "",
        clientType: "",
        startTime: "",
        endTime: "",
        category: ["funct"],
        pageSize: 20,
        page: 1,
      },
      unTagsParams: {
        version: "",
        model: "",
        server: "",
        clientType: "",
        pageSize: 20,
        page: 1,
      },
      currentItem: null,
      timer: null,
      selectData: [],
      tagCount: {
        TagTotal: 0,
        TagedCount: 0,
        unTagCount: 0,
      },
      dateType: [
        {
          type: "yesterday",
          label: "前一天",
        },
        {
          type: "7days",
          label: "7天",
        },
        {
          type: "week",
          label: "本周",
        },
        {
          type: "month",
          label: "本月",
        },
        {
          type: "year",
          label: "本年",
        },
        {
          type: "all",
          label: "全部",
        },
      ],
      serverOpts: [
        {
          value: "https://send2boox.com",
          label: "国服",
        },
        {
          value: "https://push.boox.com",
          label: "美服",
        },
        {
          value: "https://eur.boox.com",
          label: "欧服",
        },
      ],

      clientTypeOpts: [
        {
          value: "web",
          label: "WEB端",
        },
        {
          value: "pc",
          label: "PC端",
        },
        {
          value: "plugin-pc",
          label: "PC标签插件",
        },
        {
          value: "plugin-browser",
          label: "浏览器标签插件",
        },
        {
          value: "android",
          label: "Android",
        },
        {
          value: "ios",
          label: "IOS",
        },
        {
          value: "mira",
          label: "显示器",
        },
        {
          value: "device",
          label: "设备",
        },
      ],
      currentCheckTag: {},
      currentCheckTitle: "",
      action: "",
      detailsData: [],
      detailsCount: 0,
      detailsParams: {
        version: "",
        model: "",
        server: "",
        clientType: "",
        pageSize: 20,
        page: 1,
      },
      tagCategory: [],
      exportType: "tag",
      exportTagDate: "",
      exportTypeOpts: [
        {
          label: "已打标签",
          value: "tag",
        },
        {
          label: "未打标签",
          value: "unTag",
        },
      ],
    };
  },
  methods: {
    categoryToText() {
      let str = "";
      if (this.tab === "funct") {
        str = "功能";
      } else if (this.tab === "cate") {
        str = "类型";
      } else if (this.tab === "ret") {
        str = "结果";
      }
      return str;
    },

    filterHandle() {
      this.unTagsParams.version = this.paramsList.version;
      this.unTagsParams.model = this.paramsList.model;
      this.unTagsParams.server = this.paramsList.server;
      this.unTagsParams.clientType = this.paramsList.clientType;
      this.unTagsParams.startTime = this.paramsList.startTime;
      this.unTagsParams.endTime = this.paramsList.endTime;
      if (this.tab === "unTags") {
        this.unTagsParams.page = 1;
        this.getFeedbackUnTagList();
      } else {
        this.paramsList.page = 1;
        this.getList();
      }
    },

    headerTabBack(tab) {
      this.tab = tab.component;
      if (this.tab === "unTags") {
        this.unTagsParams.page = 1;
        this.getFeedbackUnTagList();
        return;
      }
      this.paramsList.page = 1;
      this.paramsList.category = [tab.component];
      this.getList();
    },

    onInput() {
      this.filterHandle();
    },

    async getFeedbackTagCategory() {
      let res = await this.$http.getFeedbackTagCategory();
      for (let item of res.data.results) {
        item.component = item.key;
        item.name = item.label;
      }
      let tempObj = { component: "unTags", name: "未打标签" };
      this.tagCategory = [...res.data.results, tempObj];
    },

    async getNoStatistical() {
      let res = await this.$http.getNoStatistical({
        startTime:
          this.datePicker && this.datePicker.length ? this.datePicker[0] : "",
        endTime:
          this.datePicker && this.datePicker.length ? this.datePicker[1] : "",
      });
      if (!res.data) return;
      this.tagCount = res.data;
    },

    changePicker() {
      [this.paramsList.startTime, this.paramsList.endTime] =
        this.datePicker && this.datePicker.length ? this.datePicker : [];
      this.getNoStatistical();
      this.filterHandle();
    },

    async exportTagData() {
      let res;
      let [startTime, endTime] =
        this.exportTagDate && this.exportTagDate.length
          ? this.exportTagDate
          : [];
      let params = {
        pageSize: 10000,
        startTime,
        endTime,
      };
      if (this.exportType === "tag") {
        res = await this.$http.exportFeedbackTag(params);
      } else if (this.exportType === "unTag") {
        res = await this.$http.exportFeedbackUnTag(params);
      }

      if (!res.data) return;
      const tempLink = document.createElement("a");
      tempLink.style.display = "none";
      document.body.appendChild(tempLink);
      tempLink.setAttribute("href", res.data);
      tempLink.click();
      document.body.removeChild(tempLink);
    },

    // changeType(type) {
    //   if (this.paramsList.dateType === type) return;
    //   this.paramsList.dateType = type;
    //   this.paramsList.page = 1;
    //   this.getNoStatistical();
    //   this.getList();
    // },

    async getFeedbackUnTagList() {
      let res = await this.$http.getFeedbackUnTagList(this.unTagsParams);
      this.total = res.data.count;
      this.tableData = res.data.list;
      this.selectData = [];
    },

    unTagsPageNum(val) {
      this.unTagsParams.page = val;
      this.getFeedbackUnTagList();
    },

    async getList() {
      try {
        let res = await this.$http.getFeedbackTagCount(this.paramsList);
        if (!res.data) return;
        this.total = res.data.count;
        this.tableData = res.data.list;
        this.selectData = [];
      } catch (error) {}
    },

    tableHandle({ type, data }) {
      if (this.action !== "checkTagDetails" && this.tab !== "unTags") {
        this.parentTableHandle(type, data);
      } else {
        this.childTableHandle(type, data);
      }
    },

    parentTableHandle(type, data) {
      if (type === this.$t("commonMsg.checkDetails")) {
        this.action = "checkTagDetails";
        this.detailsParams = Object.assign(this.detailsParams, this.paramsList);
        if (this.paramsList.startTime && this.paramsList.endTime) {
          this.dateDetailsPicker = [
            this.paramsList.startTime,
            this.paramsList.endTime,
          ];
        }
        this.detailsParams.page = 1;
        this.currentCheckTag = data.row;
        if (
          this.currentCheckTag.detail.parent &&
          this.currentCheckTag.detail.parent.length
        ) {
          this.currentCheckTitle = `${this.currentCheckTag.detail.parent[0].value} / ${this.currentCheckTag.detail.value}`;
        } else {
          this.currentCheckTitle = `${this.currentCheckTag.detail.value}`;
        }
        this.getFeedbackTagDetails();
      }
    },

    childTableHandle(type, data) {
      if (type === this.$t("commonMsg.checkDetails")) {
        this.$emit("jumpToSessionList", {
          from: "statistics",
          MsgKey: data.row.MsgKey,
        });
      }
    },

    async removeSingle(data) {
      await this.$confirm(null, "确认要移出黑名单？", {
        confirmButtonText: this.$t("commonMsg.confirm"),
        cancelButtonText: this.$t("commonMsg.cancel"),
        showClose: false,
        center: true,
      });
      await this.$tim.removeFromBlacklist([data.accountId]);
      await this.$http.delBlacklists({ ids: data._id });
      this.getList();
    },

    tableSelection(data) {
      this.selectData = data;
    },

    pageNum(val) {
      this.paramsList.page = val;
      this.getList();
    },

    // ====================== 标签详情 ==================
    onDetailInput() {
      this.detailsParams.page = 1;
      this.getFeedbackTagDetails();
    },

    changeDetailsPicker() {
      [this.detailsParams.startTime, this.detailsParams.endTime] =
        this.dateDetailsPicker && this.dateDetailsPicker.length
          ? this.dateDetailsPicker
          : [];
      this.detailsParams.page = 1;
      this.getFeedbackTagDetails();
    },
    // changeDetailsType(type) {
    //   if (this.detailsParams.dateType === type) return;
    //   this.detailsParams.page = 1;
    //   this.detailsParams.dateType = type;
    //   this.getFeedbackTagDetails();
    // },

    async getFeedbackTagDetails() {
      this.detailsParams.tags = [this.currentCheckTag.tagKey];
      let res = await this.$http.getFeedbackTagDetails(this.detailsParams);
      this.detailsData = res.data.list;
      this.detailsCount = res.data.count;
    },

    detailsPageNum(val) {
      this.detailsParams.page = val;
      this.getFeedbackTagDetails();
    },

    closeDetails() {
      this.action = "";
      this.detailsData = [];
      this.detailsCount = 0;
      this.detailsParams.page = 1;
    },
  },
  watch: {
    refresh() {
      this.getFeedbackTagCategory();
      this.getNoStatistical();
      this.tab === "unTags" ? this.getFeedbackUnTagList() : this.getList();
    },
  },
  mounted() {
    this.onInput = this.$_.debounce(this.onInput, 1000);
    this.onDetailInput = this.$_.debounce(this.onDetailInput, 1000);
    this.getFeedbackTagCategory();
    this.getNoStatistical();
    this.tab === "unTags" ? this.getFeedbackUnTagList() : this.getList();
  },
};
</script>

<style lang="scss" scoped>
.global-header-wrap {
  padding: 10px 44px;
}
.statistics-list-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .statistics-header {
    .statistics-header-top {
      flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .statistics-header-left {
        flex: 1;
        display: flex;
        align-items: center;
        > h3 + h3 {
          margin-left: 20px;
        }
        > h3 {
          > span {
            color: red;
          }
        }
      }
      .statistics-header-right {
        display: flex;
        /* flex: 1; */
        .statistics-header-export-btn {
          margin-left: 20px;
        }
        .statistics-header-export {
          display: flex;
          .statistics-header-export-handle {
            margin-right: 12px;
            padding-right: 12px;
            border-right: 1px solid #ebeef5;
          }
          .statistics-header-export-date {
            display: flex;
            flex-direction: column;
            .statistics-header-export-type {
              margin-bottom: 12px;
            }
            .statistics-header-export-tips {
              text-align: center;
              color: red;
              margin: 10px 0;
            }
          }
        }
        .statistics-date-select {
          .statistics-header-export-type {
            margin-bottom: 10px;
          }
          .statistics-date-select-item {
            display: inline-block;
            padding: 6px 12px;
            margin-left: 20px;
            font-size: 14px;
            border-radius: 4px;
            border: none;
            outline: none;
            cursor: pointer;
            -webkit-transition: all 0.3s;
            transition: all 0.3s;
            background: #ccc;
            color: #fff;
          }
          .statistics-date-select-active {
            background: #bf735b;
            color: #fff;
          }
        }
        .statistics-date-back-btn {
          margin-left: 20px;
        }
      }
    }
    .statistics-header-bottom {
      margin-top: 20px;
      .statistics-header-bottom-first,
      .statistics-header-bottom-second {
        display: flex;
        align-items: flex-end;
        > .left-part {
          margin-right: 30px;
        }
      }
      .statistics-header-bottom-second {
        margin-top: 10px;
      }
    }
  }

  .statistics-details-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .statistics-tags-card {
    background: $mainBGColor;
    .statistics-tags-container {
      margin-top: 10px;
      background: #fff;
    }
    .statistics-tags-pagination {
      background: #fff;
    }
  }
}
</style>
